enum SidebarAction {
	init = 0,
	showDetails = 1,
	addNode = 2,
	editNode = 3,
	reportPhoto = 4,
	uploadPhoto = 5,
}
export default SidebarAction;
